(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !window.DesignMode) return;
  try {
    
  window.addEventListener('load', function () {
    const modal = document.getElementById('hero-modal');
    const video = modal.querySelector('#embed-video');
    const iframe = [
      '<iframe',
      `src="${video.dataset.video}"`,
      'class="js-vimeo aspect-video w-full lazyload"',
      'frameborder="0"',
      'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen"',
      'loading="lazy"',
      '>',
      '</iframe>',
    ];

    if (modal.hasAttribute('open')) {
      video.innerHTML = iframe.join(' ');
      modal.removeAttribute('loading');
    }

    modal.addEventListener('change', () => {
      if (modal.hasAttribute('open')) {
        video.innerHTML = iframe.join(' ');
        modal.removeAttribute('loading');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-content"]) return;
  try {
    
  class ProductContentTabs extends HTMLElement {
    active = 1;
    tabs = undefined;
    tabsList = undefined;

    constructor() {
      super();

      this.tabs = this.querySelectorAll('[data-tab]');
      this.tabsList = this.querySelector('[aria-tab-list]');
      this.anchor = this.querySelector('[aria-product-content-tabs-anchor]');
      this.toggleTab.bind(this);

      this.tabsList.addEventListener(
        'click',
        (event) => {
          let target = event.target;

          if (target.tagName !== 'BUTTON' && target.closest('[data-target]').tagName !== 'BUTTON') return;

          if (target.tagName !== 'BUTTON') {
            target = target.closest('[data-target]');
          }

          const tab = target.dataset.target;
          if (tab === null) return;

          this.toggleTab(tab);
        },
        false
      );
    }

    toggleTab(tab) {
      if (this.active === tab) return;

      const tablist = this.tabsList.childNodes;

      this.tabs.forEach((item) => {
        if (item.dataset.tab === tab) {
          item.setAttribute('open', true);
        } else {
          item.removeAttribute('open');
        }
      });

      tablist.forEach((item) => {
        const target = item.querySelector('[data-target]').dataset.target;

        if (target === tab) {
          item.setAttribute('open', true);
        } else {
          item.removeAttribute('open');
        }
      });

      this.anchor.scrollIntoView({ behavior: 'smooth' });
      this.active = tab;
    }
  }

  customElements.define('product-content-tabs', ProductContentTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(data => {
            const html = document.createElement('div');
            html.innerHTML = data;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !window.DesignMode) return;
  try {
    
class ExpanseText extends HTMLElement {
  constructor() {
    super();

    this.querySelector('[aria-expand-action]').addEventListener('click', (event) => {
      event.preventDefault();

      this.toggleAttribute('open');
    });
  }
}

customElements.define('expanse-text', ExpanseText);

  } catch(e) { console.error(e); }
})();
})();
